import innerStyles from "./buttonsBlock.module.css";
import cn from "classnames";

export default function ButtonsBlock({
  handleSaveBtn,
  handleCloseBtn,
  handleDeclineBtn,
  handleExtraBtn,
  saveBtnText,
  closeBtnText,
  declineBtnText,
  extraBtnText,
  styles,
  mobileFullScreen,
}) {
  return (
    <div
      className={cn(innerStyles["buttons-block"], {
        [innerStyles["buttons-full-screensize"]]: mobileFullScreen,
      })}
    >
      {closeBtnText && (
        <div
          id="close"
          className={cn(
            innerStyles["close-btn"],
            styles?.["close-btn-external"],
          )}
          onClick={handleCloseBtn}
        >
          {closeBtnText}
        </div>
      )}
      {declineBtnText && (
        <div
          id="decline"
          className={cn(
            innerStyles["decline-btn"],
            styles?.["decline-btn-external"],
          )}
          onClick={handleDeclineBtn}
        >
          {declineBtnText}
        </div>
      )}
      {extraBtnText && (
        <div
          id="extra"
          className={innerStyles["extra-btn"]}
          onClick={(e) => handleExtraBtn(e)}
        >
          {extraBtnText}
        </div>
      )}
      {saveBtnText && (
        <button
          id="save"
          className={cn(innerStyles["save-btn"], styles?.["save-btn-external"])}
          onClick={() => !!handleSaveBtn && handleSaveBtn()}
        >
          {saveBtnText}
        </button>
      )}
    </div>
  );
}
